// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__m+fW9","section-1":"styles_section-1__1gmKd","content":"styles_content__tK6kq","section-2":"styles_section-2__L-gMJ"};